import { APITransport } from '@client/transports/api';

export const DiagnosticsService = {
  parseEmail(body) {
    return APITransport.post({
      path: '/rest/domain/execute/parseemail',
      body
    });
  }
};
